export function isValidFirstName(name) {
  return name ? (name.length > 0 || "First name is required") : "First name is required"
}

export const rules = [isValidFirstName]
